import {forwardRef, Ref, useImperativeHandle, useRef} from 'react';
import emailSentIcon from '../../../assets/auth/email_sent_icon.svg';
import Loader, {ILoaderRef} from '../../../com/loader/Loader';

import './EmailSent.scss'

export interface IEmailSentRef {
    showLoader: (value: boolean) => void
}

interface IEmailSent {
    onResendAnotherEmailClick: () => void
}

export const EmailSent = forwardRef((props: IEmailSent, ref: Ref<IEmailSentRef>) => {

    const loader = useRef<ILoaderRef>(null);

    useImperativeHandle(ref, () => ({showLoader}));

    const showLoader = (value: boolean) => {
        if (loader != null) {
            loader.current?.showLoader(value);
        }
    }

    return (
        <div className="auth_item_container registration_email_send">

            <img src={emailSentIcon} alt={"No Image"}/>

            <p>Email has been sent</p>

            <p>We have sent an email to your email adress. Click the confirmation link and Sign In please.</p>

            <p>If you did not recieve an email please press</p>

            <div onClick={props.onResendAnotherEmailClick}>Resend another Email</div>

            <Loader ref={loader}/>

        </div>
    )
})